import React from "react";
import { COLORS } from "../../utils/constants";
import { formatCurrency } from "../../utils/formatters";

export const SeuilBar = ({ label, seuil, avant, apres, reste, alerte, testid }) => {
  const pAv = Math.min(100, avant);
  const pAp = Math.min(100, apres);
  const color = alerte ? COLORS.error : COLORS.accent;
  return (
    <div data-testid={testid}>
      <div className="flex justify-between text-xs mb-1">
        <span className="font-medium" style={{ color: COLORS.text }}>{label}</span>
        <span className="text-muted-foreground">seuil {formatCurrency(seuil)}</span>
      </div>
      <div className="h-3 rounded-full bg-gray-100 relative overflow-hidden">
        <div className="absolute inset-y-0 left-0 rounded-full" style={{ width: `${pAp}%`, backgroundColor: color + "55" }} />
        <div className="absolute inset-y-0 left-0 rounded-full" style={{ width: `${pAv}%`, backgroundColor: color }} />
      </div>
      <div className="flex justify-between text-[11px] mt-1 text-muted-foreground">
        <span><span className="inline-block w-2 h-2 rounded-full mr-1" style={{ backgroundColor: color }} />actuel {pAv}%</span>
        <span><span className="inline-block w-2 h-2 rounded-full mr-1" style={{ backgroundColor: color + "55" }} />avec le contrat {pAp}%</span>
        <span className="font-semibold" style={{ color }}>{alerte || `reste ${formatCurrency(reste)}`}</span>
      </div>
    </div>
  );
};

export default SeuilBar;
